export default __webpack_public_path__ + "static/media/cha_medic_ceylon.99abd20a.png";